/* eslint-disable react/jsx-no-undef */
import classes from 'classnames';
import { prop } from 'ramda';

import styles from './index.module.css';

const AuthTitle = ({ className, children, size, hint, noBorder, bracketsText, ...rest }) => {
  const wrapperClasses = classes(
    styles.wrapper,
    'custom-auth-title-wrapper',
    noBorder && prop('wrapper-noBorder', styles),
    className,
  );

  const AuthTitleClasses = classes(
    styles.authTitle,
    'custom-auth-title',
    size && prop(`authTitle-${size}`, styles),
    className,
  );

  return (
    <div className={wrapperClasses}>
      <div className={AuthTitleClasses} {...rest}>
        <span>{children}</span>

        {bracketsText && <span className={styles.brackets}>{bracketsText}</span>}
      </div>
      {hint && <Text accent>{hint}</Text>}
    </div>
  );
};

export default AuthTitle;
